var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app flex-row align-items-center bg-gray-50"
  }, [_c('Toast'), _c('div', {
    staticClass: "container flex relative justify-center h-screen items-center bg-gray-50 text-left"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_vm._m(0), _c('div', {
    staticClass: "rounded-lg h-auto p-4 border shadow-md flex justify-center bg-white"
  }, [_c('div', {
    staticClass: "flex-col w-full justify-center"
  }, [_c('h4', {
    staticClass: "font-bold mt-4 mb-3"
  }, [_vm._v("Enter your registered email")]), _c('p', {
    staticClass: "text-base"
  }, [_vm._v("We will send you the link that will direct you to reset the password.")]), _c('div', {
    staticClass: "mt-0 w-full"
  }, [_c('label', {
    staticClass: "block w-full mb-2 text-sm font-medium text-gray-700",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.Form.email,
      expression: "Form.email"
    }],
    staticClass: "shadow-sm text-gray-500 bg-gray-50 border p-2.5 w-full rounded-lg",
    class: _vm.errors.email ? 'bg-red-50 border-red-500' : 'border',
    attrs: {
      "type": "text",
      "placeholder": "name@example.com",
      "autocomplete": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.Form.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Form, "email", $event.target.value);
      }, _vm.validateEmail]
    }
  }), _vm.errors.email ? _c('div', {
    staticClass: "text-red-500 text-sm mt-2"
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e(), _c('button', {
    staticClass: "text-white w-full p-2.5 mt-4 mb-2 rounded-md",
    class: !_vm.isEmailValid ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500',
    attrs: {
      "disabled": !_vm.isEmailValid
    },
    on: {
      "click": _vm.actionForget
    }
  }, [_vm._v(" Send "), _vm.isLoading ? _c('svg', {
    staticClass: "inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600",
    attrs: {
      "aria-hidden": "true",
      "role": "status",
      "viewBox": "0 0 100 101",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      "fill": "#1C64F2"
    }
  })]) : _vm._e()]), _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('button', {
    staticClass: "text-blue-500 w-full p-2.5 mt-0 mb-2 rounded-md"
  }, [_vm._v("Back")])])], 1)])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "mb-4",
    attrs: {
      "src": require("../../assets/img/gramedia_digital.png"),
      "alt": "Gramedia Digital"
    }
  })]);
}]

export { render, staticRenderFns }